import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

import { VpDialogContent } from '@vp-ui/components';
import { VpHookFormWrapper } from '@vp-ui/wrappers';

import CreateCompilationForm from '@vp-ui/dialogs/CreateCompilationDialog/CreateCompilationForm';
import { usePostVideoCompilationPage } from '@src/hooks';
import { withRouter } from 'react-router';
import { EDIT_LIBRARY_PREFIX } from '@src/app_routes';

export const CreateCompilationDialog = withRouter(
  ({ history, onClose = () => { }, open = 'false' }) => {
    const {
      mutate: postVideoCompilationPage,
      isSuccess,
      data: createCompilationResponse,
    } = usePostVideoCompilationPage();

    const onSubmit = (formData) => {
      const payload = {
        title: formData?.title,
        campaignId: parseInt(formData?.campaignId),
      };

      postVideoCompilationPage(payload);
    };

    useEffect(() => {
      if (isSuccess && createCompilationResponse?.pageLink) {
        history.push(`/${EDIT_LIBRARY_PREFIX}/${createCompilationResponse?.pageLink}`);
        onClose();
      }
    }, [createCompilationResponse]);

    return (
      <Dialog
        maxWidth="sm"
        fullWidth
        onClose={onClose}
        open={open}
        data-testid="create-video-compilation-modal"
      >
        <VpDialogContent disablePadding>
          <VpHookFormWrapper onSubmit={onSubmit} formData={{ mode: 'all' }}>
            <CreateCompilationForm onCancel={onClose} />
          </VpHookFormWrapper>
        </VpDialogContent>
      </Dialog>
    );
  }
);

CreateCompilationDialog.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export default CreateCompilationDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/CreateCompilationDialog/CreateCompilationDialog.jsx